<template>
  <div>
    <div class="ts-flex ts-items-center ts-space-x-2">
      <h1 class="ts-font-robot ts-text-base ts-mb-0 ts-uppercase">
        Report to sub task: {{ edit_data.title }}
      </h1>
      <button
        @click.prevent="showFormCreated"
        class="ts-w-6 ts-h-6 ts-bg-blue-500 ts-rounded-full ts-flex ts-items-center ts-justify-center focus:ts-outline-none"
      >
        <Icon type="ios-add" size="20" class="ts-text-white" />
      </button>
    </div>
    <div v-if="isShowCreate">
      <div class="ts-flex ts-space-x-4 ts-mt-2">
        <div class="ts-whitespace-no-wrap">
          <a-radio-group v-model="stockType" @change="fetchBorrowing">
            <a-radio-button value="vendor">Vendor</a-radio-button>
            <a-radio-button value="customer">Customer</a-radio-button>
          </a-radio-group>
        </div>
        <a-select
          v-model="selectedBorrowing"
          style="width: 100%;"
          placeholder="Please borrowing spare part"
          :options="borrowingSparePart"
          @change="fetchProduct"
        ></a-select>
      </div>

      <table class="ts-w-full ts-mt-3">
        <thead>
          <tr class="ts-bg-blue-100">
            <th class="ts-font-robot ts-uppercase ts-text-sm ts-py-1 ts-px-2">
              {{ $t('task.productName') }}
            </th>
            <th
              class="ts-font-robot ts-uppercase ts-text-sm ts-py-1 ts-px-2 ts-w-48"
            >
              {{ $t('task.uom') }}
            </th>
            <th
              class="ts-font-robot ts-uppercase ts-text-sm ts-py-1 ts-px-2 ts-w-24 ts-whitespace-no-wrap"
            >
              {{ $t('task.startPoint') }}
            </th>
            <th
              class="ts-font-robot ts-uppercase ts-text-sm ts-py-1 ts-px-2 ts-w-24 ts-whitespace-no-wrap"
            >
              {{ $t('task.endPoint') }}
            </th>
            <th
              class="ts-font-robot ts-uppercase ts-text-sm ts-py-1 ts-px-2 ts-w-24"
            >
              {{ $t('task.quantity') }}
            </th>
            <th
              class="ts-font-robot ts-uppercase ts-text-sm ts-py-1 ts-px-2 ts-w-48"
            >
              {{ $t('task.remark') }}
            </th>
            <th
              class="ts-font-robot ts-uppercase ts-text-sm ts-py-1 ts-px-2 ts-w-10 ts-text-center"
            >
              <a href="#" @click.prevent="addRow"
                ><Icon type="md-add-circle" size="25"
              /></a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(p, index) in model.products" :key="index">
            <td
              class="ts-font-roboto ts-text-base ts-py-1 ts-px-2"
              valign="top"
            >
              <Select
                v-model="p.product_id"
                :filterable="true"
                style="width:100%"
                @on-change="onProductChange(p)"
              >
                <Option
                  v-for="item in products"
                  :value="item.product_id"
                  :key="item.product_id"
                  >{{ item.product_name_en }}</Option
                >
              </Select>
              <div
                v-if="errors.has('products.' + index + '.product_id')"
                class="ts-text-red-600 ts-text-xs"
              >
                {{ errors.first('products.' + index + '.product_id') }}
              </div>
            </td>
            <td
              class="ts-font-roboto ts-text-base ts-py-1 ts-px-2"
              valign="top"
            >
              <Select
                v-model="p.uom_id"
                :filterable="true"
                style="width:100%"
                @on-change="onGetPrice(p)"
              >
                <Option
                  v-for="item in uomList(p.product_id)"
                  :value="item.uom_id"
                  :key="item.uom_id"
                  >{{ item.uom_name_en }}</Option
                >
              </Select>
              <div
                v-if="errors.has('products.' + index + '.uom_id')"
                class="ts-text-red-600 ts-text-xs"
              >
                {{ errors.first('products.' + index + '.uom_id') }}
              </div>
            </td>
            <td
              class="ts-text-base ts-text-center ts-py-1 ts-px-2 ts-w-24"
              valign="top"
            >
              <Input
                type="number"
                v-model.number="p.start_point"
                placeholder="Start Point"
                style="width: 100%"
                @input="calculateLength(p)"
              />
              <div
                v-if="errors.has('products.' + index + '.start_point')"
                class="ts-text-red-600 ts-text-xs"
              >
                {{ errors.first('products.' + index + '.start_point') }}
              </div>
            </td>
            <td
              class="ts-text-base ts-text-center ts-py-1 ts-px-2 ts-w-24"
              valign="top"
            >
              <Input
                type="number"
                v-model.number="p.end_point"
                placeholder="Start Point"
                style="width: 100%"
                @input="calculateLength(p)"
              />
              <div
                v-if="errors.has('products.' + index + '.end_point')"
                class="ts-text-red-600 ts-text-xs"
              >
                {{ errors.first('products.' + index + '.end_point') }}
              </div>
            </td>
            <td
              class="ts-font-roboto ts-text-base ts-text-center ts-py-1 ts-px-2"
              valign="top"
            >
              <Input
                type="number"
                v-model.number="p.quantity"
                placeholder="Quantity"
                style="width: 100%"
              />
              <div
                v-if="errors.has('products.' + index + '.quantity')"
                class="ts-text-red-600 ts-text-xs"
              >
                {{ errors.first('products.' + index + '.quantity') }}
              </div>
            </td>
            <td
              class="ts-font-roboto ts-text-base ts-text-center ts-py-1 ts-px-2"
              valign="top"
            >
              <Input
                type="text"
                v-model.trim="p.remark"
                placeholder="Remark"
                style="width: 100%"
              />
            </td>
            <td
              class="ts-font-roboto ts-text-base ts-py-1 ts-px-2 ts-text-center"
            >
              <a href="#" @click.prevent="remove(index)"
                ><Icon type="md-close" size="20" class="ts-text-red-600"
              /></a>
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <div class="row">
        <div
          class="col-md-12 ts-flex ts-items-center ts-justify-end ts-space-x-3"
        >
          <ts-button @click.prevent="isShowCreate = false"
            >{{ $t('cancel') }}
          </ts-button>

          <ts-button
            :disabled="loading"
            @click.prevent="onReport"
            color="primary"
            >{{ $t('save') }}</ts-button
          >
        </div>
      </div>
    </div>
    <br />
    <div v-if="!isShowCreate">
      <div v-for="(report, date) in reportList" :key="date">
        <h1 class="ts-border-b ts-border-dashed ts-text-sm">
          {{ date }}
        </h1>
        <div class="ts-pl-12 ts-p-2">
          <table class="ts-w-full">
            <thead>
              <tr
                style="background-color: #f8f8f9"
                class="ts-whitespace-no-wrap"
              >
                <th class="ts-uppercase ts-text-sm ts-px-2 ts-w-1/4">
                  {{ $t('task.productName') }}
                </th>
                <th class="ts-uppercase ts-text-sm ts-px-2 ts-w-24">
                  {{ $t('task.uom') }}
                </th>
                <th class="ts-uppercase ts-text-sm ts-px-2 ts-w-12">
                  {{ $t('task.startPoint') }}
                </th>
                <th class="ts-uppercase ts-text-sm ts-px-2 ts-w-12">
                  {{ $t('task.endPoint') }}
                </th>
                <th class="ts-uppercase ts-text-sm ts-px-2 ts-w-12">
                  {{ $t('task.quantity') }}
                </th>
                <th class="ts-uppercase ts-text-sm ts-px-2">
                  {{ $t('task.remark') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in report"
                :key="index"
                class="ts-border-b"
              >
                <td class=" ts-text-sm ts-px-2">
                  {{ item.product_name_en }}
                </td>
                <td class=" ts-text-sm ts-px-2">
                  {{ item.uom_name_en }}
                </td>
                <td class=" ts-text-sm ts-text-center ts-px-2">
                  {{ item.start_point }}
                </td>
                <td class=" ts-text-sm ts-text-center ts-px-2">
                  {{ item.end_point }}
                </td>
                <td class=" ts-text-sm ts-text-center ts-px-2">
                  {{ item.quantity }}
                </td>
                <td class=" ts-text-sm ts-px-2">
                  {{ item.remark }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
export default {
  props: ['edit_data'],
  data() {
    return {
      loading: false,
      products: [],
      uom: [],
      errors: new Errors(),
      isShowCreate: false,
      resource: [],
      selectedBorrowing: '',
      borrowingSparePart: [],
      stockType: 'vendor',
      model: {
        products: [
          {
            product_id: '',
            uom_id: '',
            unit_price: 0,
            quantity: '',
            remark: '',
            sfo_id: '',
            start_point: '',
            end_point: ''
          }
        ]
      }
    }
  },
  computed: {
    uomList: vm => productId => {
      let findProduct = vm.products.find(p => p.product_id == productId)
      if (findProduct) {
        return vm.uom.filter(u => u.uom_cat_id == findProduct.uom_cat_id)
      }
      return []
    },
    reportList() {
      if (this.resource) {
        return this.resource.reduce((acc, item) => {
          const { created_date, ...rest } = item
          if (acc[created_date]) {
            acc[created_date].push(rest)
          } else {
            acc[created_date] = [rest]
          }
          return acc
        }, {})
      }

      return []
    }
  },
  created() {
    this.fetchReport()
  },
  methods: {
    ...mapActions('projectMgt/taskProfile', ['formViewModel']),
    ...mapActions('projectMgt/subTaskProfile', ['report', 'getReport']),
    addRow() {
      this.model.products.push({
        product_id: '',
        uom_id: '',
        quantity: '',
        unit_price: 0,
        sfo_id: '',
        start_point: '',
        end_point: ''
      })
    },
    remove(index) {
      this.model.products.splice(index, 1)
    },
    fetchModel() {
      this.loading = true
      this.formViewModel({
        fnName: 'product,uom'
      })
        .then(response => {
          this.products = response.data.product
          this.uom = response.data.uom
        })
        .finally(() => (this.loading = false))
    },
    onProductChange(row) {
      let findProduct = this.products.find(p => p.product_id == row.product_id)
      let defaultUom = this.uom.find(
        u => u.uom_cat_id == findProduct.uom_cat_id && u.is_default == true
      )
      row.uom_id = defaultUom.uom_id

      // get sfo id
      const sfo = this.products.find(el => el.product_id == row.product_id)
      row.sfo_id = sfo.sfo_id

      this.onGetPrice(row)
    },
    onGetPrice(row) {
      if (row.uom_id) {
        this.loading = true
        this.formViewModel({
          fnName: 'getSalePrice',
          product_id: row.product_id,
          uom_id: row.uom_id
        })
          .then(response => {
            row.unit_price = response.data.getSalePrice[0].sale_price
          })
          .finally(() => (this.loading = false))
      }
    },
    showFormCreated() {
      this.isShowCreate = true
      this.fetchBorrowing()
      this.fetchUom()
      // this.fetchModel()
    },
    onReport() {
      this.loading = true
      this.report({
        id: this.edit_data.id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.isShowCreate = false
          this.clearInput()
          this.fetchReport()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.loading = false))
    },
    fetchReport() {
      this.loading = true
      this.getReport(this.edit_data.id)
        .then(response => {
          this.resource = response.data
          if (this.isShowCreate) {
            this.fetchModel()
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    clearInput() {
      this.model.products = [
        {
          product_id: '',
          uom_id: '',
          quantity: '',
          unit_price: 0,
          remark: '',
          sfo_id: '',
          start_point: '',
          end_point: ''
        }
      ]
    },
    fetchProduct(value) {
      this.loading = true
      this.formViewModel({
        fnName: 'product',
        sfoId: value
      })
        .then(response => {
          this.products = response.data.product
        })
        .finally(() => (this.loading = false))
    },
    fetchUom() {
      this.loading = true
      this.formViewModel({
        fnName: 'uom'
      })
        .then(response => {
          this.uom = response.data.uom
        })
        .finally(() => (this.loading = false))
    },
    fetchBorrowing() {
      this.selectedBorrowing = []
      this.model.products = []
      this.addRow()
      this.loading = true
      this.formViewModel({
        fnName: 'borrowingSparePart',
        stockType: this.stockType
      })
        .then(response => {
          this.borrowingSparePart = response.data.borrowingSparePart.map(
            el => ({
              value: el.sfo_id,
              label: el.sfo_number
            })
          )
        })
        .finally(() => (this.loading = false))
    },
    calculateLength(row) {
      if (row.start_point !== '' && row.end_point != '') {
        row.quantity = row.end_point - row.start_point
      }
    }
  }
}
</script>
